import { render } from "./ArchivedTask.vue?vue&type=template&id=fb5cfc8c&scoped=true"
import script from "./ArchivedTask.vue?vue&type=script&lang=js"
export * from "./ArchivedTask.vue?vue&type=script&lang=js"

import "./ArchivedTask.vue?vue&type=style&index=0&id=fb5cfc8c&scoped=true&lang=scss"

import exportComponent from "/home/tabelka-front/tabelka.expansja.pl/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb5cfc8c"]])

export default __exports__